import { Component, NgModule, OnDestroy, OnInit } from '@angular/core';
import {
  MatTableModule,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { PatientLinkComponentModule, PatientLinkComponent } from '../../../../components/patient-link/patient-link.component';
import { BaseReportTableComponent } from '../../../../components/base-report-table/base-report-table.component';
import { TreatmentDateComponent } from '../../../../components/treatment-date/treatment-date.component';
import { SurgicalFollowUpVisitsReportRecord } from '../../surgical-follow-up-visits-report.model';
import { surgeryFollowUpFull } from '@utils/routing.utils';
import { SimpleReportCellComponentModule } from '@src/app/features/reports/components/simple-report-cell/simple-report-cell.component';
import { SimpleReportCellComponent } from '../../../../components/simple-report-cell/simple-report-cell.component';
import { TreatmentStatusIndicatorComponent } from '@shared/components/treatment-status-indicator/treatment-status-indicator.component';
import { EmptyTableStateComponent } from '@shared/components/empty-table-state/empty-table-state.component';
import { YesNoPipe } from '@shared/modules/readonly-commons/pipes/yes-no/yes-no.pipe';
import { ReportType } from '@src/app/features/reports/components/report-filters/models/report-filters.model';

@Component({
  selector: 'stx-surgical-follow-up-visits-report-table',
  templateUrl: './surgical-follow-up-visits-report-table.component.html',
  imports: [
    MatPaginator,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    SimpleReportCellComponent,
    PatientLinkComponent,
    TreatmentStatusIndicatorComponent,
    TreatmentDateComponent,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    EmptyTableStateComponent,
    YesNoPipe,
    TranslateModule
  ]
})
export class SurgicalFollowUpVisitsReportTableComponent
  extends BaseReportTableComponent<SurgicalFollowUpVisitsReportRecord>
  implements OnInit, OnDestroy
{
  readonly reportType: ReportType = 'SURGICAL_FOLLOW_UP_VISITS';

  displayedColumns: string[] = ['treatmentCenter', 'patient', 'surgeryFollowUp'];
  surgeryFollowUpFull = surgeryFollowUpFull;

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.onInit();
  }

  ngOnDestroy(): void {
    super.onDestroy();
  }
}

@NgModule({
  imports: [
    MatTableModule,
    MatSortModule,
    TranslateModule,
    CommonModule,
    MatIconModule,
    RouterModule,
    MatPaginatorModule,
    PatientLinkComponentModule,
    SimpleReportCellComponentModule,
    SurgicalFollowUpVisitsReportTableComponent
  ],
  exports: [SurgicalFollowUpVisitsReportTableComponent]
})
export class SurgicalFollowUpVisitsReportTableComponentModule {}
